/*
  COREEX countdown top bar.

  A dedicated copy of the countdown logic keyed to `.coreex-cdtop`, kept
  separate from section-countdown-bar.js on purpose so the top strip and the
  larger home-page countdown can never interfere with each other.

  Modes:
    - fixed:     count to a date/time in the visitor's LOCAL time.
    - evergreen: a fixed per-visitor duration, persisted in localStorage so it
                 survives reloads and navigation.
  On expiry: show a message, or hide the bar (never hidden in the theme editor,
  where the merchant needs to see it).
*/
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function designMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function getTarget(root, mode) {
    if (mode === 'evergreen') {
      var mins = parseFloat(root.getAttribute('data-duration')) || 0;
      if (mins <= 0) return null;
      var key = 'coreex-cdtop-' + (root.getAttribute('data-storage-key') || root.id);
      var end;
      try {
        var stored = localStorage.getItem(key);
        if (stored) {
          end = parseInt(stored, 10);
        } else {
          end = Date.now() + mins * 60000;
          localStorage.setItem(key, end);
        }
      } catch (e) {
        // localStorage blocked (private mode etc.) -> non-persistent fallback
        end = Date.now() + mins * 60000;
      }
      return new Date(end);
    }

    // fixed
    var date = root.getAttribute('data-end-date');
    var time = root.getAttribute('data-end-time') || '23:59';
    if (!date) return null;
    var t = new Date(date + 'T' + time);
    return isNaN(t.getTime()) ? null : t;
  }

  function initSection(root) {
    if (!root || root.__cdtopInit) return;
    root.__cdtopInit = true;

    var mode = root.getAttribute('data-countdown-mode');
    var behavior = root.getAttribute('data-expired-behavior') || 'message';
    var loop = root.getAttribute('data-loop') === 'true';
    var durationMs = (parseFloat(root.getAttribute('data-duration')) || 0) * 60000;
    var storageKey = 'coreex-cdtop-' + (root.getAttribute('data-storage-key') || root.id);
    var timerEl = root.querySelector('.coreex-cdtop__timer');
    var expiredEl = root.querySelector('.coreex-cdtop__expired');
    var dEl = root.querySelector('[data-cd-days]');
    var hEl = root.querySelector('[data-cd-hours]');
    var mEl = root.querySelector('[data-cd-mins]');
    var sEl = root.querySelector('[data-cd-secs]');

    var target = getTarget(root, mode);
    if (!target) return;

    function set(el, val) {
      if (el) el.textContent = val;
    }

    function expire() {
      if (root.__cdtopTimer) {
        clearInterval(root.__cdtopTimer);
        root.__cdtopTimer = null;
      }
      if (behavior === 'hide' && !designMode()) {
        root.style.display = 'none';
        return;
      }
      if (timerEl) timerEl.style.display = 'none';
      if (expiredEl) expiredEl.hidden = false;
    }

    function tick() {
      var diff = target.getTime() - Date.now();
      if (diff <= 0) {
        // Loop (evergreen / per-visitor only): instead of expiring, restart a
        // fresh full duration and persist the new end so a reload continues the
        // new cycle. Fixed-date timers are never looped.
        if (loop && mode === 'evergreen' && durationMs > 0) {
          var restart = Date.now() + durationMs;
          target = new Date(restart);
          try { localStorage.setItem(storageKey, restart); } catch (e) {}
          diff = durationMs;
        } else {
          set(dEl, '00');
          set(hEl, '00');
          set(mEl, '00');
          set(sEl, '00');
          expire();
          return;
        }
      }
      var total = Math.floor(diff / 1000);
      set(dEl, pad(Math.floor(total / 86400)));
      set(hEl, pad(Math.floor((total % 86400) / 3600)));
      set(mEl, pad(Math.floor((total % 3600) / 60)));
      set(sEl, pad(total % 60));
    }

    tick();
    root.__cdtopTimer = setInterval(tick, 1000);
  }

  function initAll(scope) {
    var nodes = (scope || document).querySelectorAll('.coreex-cdtop');
    for (var i = 0; i < nodes.length; i++) initSection(nodes[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.coreex-cdtop');
    if (r) {
      r.__cdtopInit = false;
      r.style.display = '';
      initSection(r);
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('.coreex-cdtop');
    if (r && r.__cdtopTimer) {
      clearInterval(r.__cdtopTimer);
      r.__cdtopTimer = null;
    }
  });
})();
